<div class="h-full w-full flex flex-column align-items-start justify-content-between">
    <div class="w-full h-3rem flex align-items-center justify-content-center relative">
        <p-button class="absolute left-0" label="Annuler" [rounded]="true" [text]="true"
            (click)="onClickCancel()"></p-button>
        <span class="font-semibold text-xl">Nouvelle discussion</span>
        <p-button class="absolute right-0" label="Créer" [rounded]="true" [text]="true" [disabled]="createDisabled"
            (click)="onClickSave()"></p-button>
    </div>
    <div class="flex-grow-1 w-full flex flex-column align-items-start justify-content-start gap-5">

        <!-- Titre de la conversation -->
        <input type="text" placeholder="Titre de la discussion (facultatif)"
            class="w-full border-none bg-transparent p-3 outline-none" [(ngModel)]="conversation.title"
            [ngClass]="{'placeholder-text': !form.get('message')?.value}" autoFocus />

        <!-- Liste des contacts du client -->
        <div class="p-3 text-lg text-500">
            Sélectionnez les participants à la discussion
        </div>
        @if (!loadingContacts) {
        <div class="w-full flex flex-column">
            @for (contact of availableContacts; track contact.id) {
            <div class="p-3 grid grid-nogutter cursor-pointer hover:bg-blue-50"
                [ngClass]="{ 'surface-50': contact.selected }" (click)="onClickContact(contact)">
                <div class="col-1">
                    <app-avatar [user]="contact.contact.user" size="xlarge"></app-avatar>
                </div>
                <div class="col-10 flex flex-column justify-content-around align-items-start">
                    <span class="text-xl font-semibold">{{ contact.contact.fullName }}</span>
                    <span class="text-md text-500">{{ contact.contact.email }}</span>
                </div>
                <div class="col-1 flex align-items-center justify-content-center">
                    <p-checkbox size="large" [binary]="true" [(ngModel)]="contact.selected" />
                </div>
            </div>
            }
        </div>
        } @else {
        <div class="flex justify-content-center align-items-center flex-grow-1 w-full">
            <p-progressSpinner></p-progressSpinner>
        </div>
        }

        <!-- Éventuelle liste des contacts du partenaire (enfin ça se trouve on va mixer...) -->
    </div>
</div>